import { configureStore } from "@reduxjs/toolkit";
import modulesReducer from "../Courses/Modules/reducer";
import assignmentsReducer from "../Courses/Assignments/assignmentsReducer";

export interface KanbasState {
  modulesReducer: {
    modules: any[];
    module: any;
  };
  assignmentsReducer: {
    assignments: any[];
    selectedAssignmentId: any;
  };
}
const store = configureStore({
  reducer: {
    modulesReducer, 
    assignmentsReducer, 
  },
});

export default store;